import {mapGetters} from "vuex";

const PushIfExists = {
  methods: {
    pushIfExists(to) {
      const matchingRoute = this.getMatchingRoute(to);

      if (matchingRoute) {
        this.$router.push(to);
      }
    },
  },
  computed: {
    ...mapGetters([
      'getMatchingRoute'
    ])
  }
}

export default PushIfExists
